<template>
  <v-container id="user-personal">
    <v-row justify="center">
      <v-col style="max-width: 650px">
        <v-card outlined>
          <v-card-title><span v-t="'User information '" /></v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-action class="d-none d-sm-block">
                  <input-icon>mdi-account</input-icon>
                </v-list-item-action>
                <UpdateUserName v-if="user" />
              </v-list-item>
              <v-list-item>
                <v-list-item-action class="d-none d-sm-block">
                  <input-icon>mdi-email</input-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <span class="use-text-subtitle2 d-inline">
                    <v-text-field
                      name="email"
                      :label="$t('Username / email')"
                      readonly
                      :value="$store.state.user.email"
                    ></v-text-field>
                  </span>
                </v-list-item-content>
                <v-list-item-action><UpdateUserEmailModal v-if="user" /></v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UpdateUserEmailModal from "./UpdateUserEmailModal";
import UpdateUserName from "./UpdateUserName";

export default {
  components: {
    UpdateUserName,
    UpdateUserEmailModal,
  },
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
#user-personal {
  .v-list-item__action {
    // @media only screen and (max-width: 500px) {
    //   display: none;
    // }
  }
  .v-list-item__content {
    max-width: 400px;
    width: 100%;
    // min-width: 230px;
  }
}
</style>
